const translations = {
  title: 'Użytkownicy',
};

export default translations;
